export default __webpack_public_path__ + "static/media/baya-bird-3.6a161f3c.gif";